if (!customElements.get('crm-lead-form')) {
  class CrmLeadForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.requestId = globalThis.crypto?.randomUUID?.() || `lead-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      this.prefill();
      this.form.addEventListener('submit', (event) => this.submit(event));
      const submitButton = this.form.querySelector('[data-js-submit]');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
      }
    }

    prefill() {
      const params = new URLSearchParams(window.location.search);
      const vehicle = params.get('vehicle') || params.get('model');
      const stock = params.get('stock');
      const manufacturer = params.get('manufacturer');
      const source = params.get('source');
      const variant = params.get('variant');
      const crmKey = params.get('crm_key');
      const productId = params.get('product_id');
      const variantId = params.get('variant_id');
      const vendor = params.get('vendor');
      const pageType = params.get('page_type');
      if (manufacturer) this.dataset.manufacturer = manufacturer;
      if (vendor && !manufacturer) this.dataset.manufacturer = vendor;
      if (source) this.dataset.source = source;
      if (crmKey) this.dataset.crmMatchKey = crmKey;
      if (productId) this.dataset.productId = productId;
      if (variantId) this.dataset.variantId = variantId;
      if (pageType) this.dataset.pageType = pageType;
      const preferredDate = this.form.elements.preferred_date;
      if (preferredDate) {
        const now = new Date();
        preferredDate.min = new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
      }
      if (vehicle && this.form.elements.vehicle_interest) this.form.elements.vehicle_interest.value = vehicle;
      if (stock && this.form.elements.stock_number) this.form.elements.stock_number.value = stock;
      if (vehicle && this.form.elements.message && !this.form.elements.message.value) {
        this.form.elements.message.value = `I’m interested in ${vehicle}${variant ? ` — ${variant}` : ''}${stock ? ` (stock #${stock})` : ''}.`;
      }
    }

    status(message, state = '') {
      const node = this.querySelector('[data-lead-status]');
      if (!node) return;
      node.textContent = message;
      node.dataset.state = state;
    }

    payload() {
      const data = Object.fromEntries(new FormData(this.form).entries());
      return {
        ...data,
        module: 'Leads',
        workflow: this.dataset.workflow || 'zoho_crm_lead',
        routing_key: this.dataset.routingKey || 'sales',
        lead_source: 'Website',
        lead_type: this.dataset.leadType || 'Sales Inquiry',
        manufacturer: this.dataset.manufacturer || data.manufacturer || '',
        stock_number: data.stock_number || this.dataset.stockNumber || '',
        crm_match_key: this.dataset.crmMatchKey || '',
        product_id: this.dataset.productId || '',
        variant_id: this.dataset.variantId || '',
        page_type: this.dataset.pageType || '',
        request_id: this.requestId,
        destination_email: this.dataset.destinationEmail,
        source: this.dataset.source || 'shopify_crm_lead_form',
        page_title: document.title,
        page_url: window.location.href,
        submitted_at: new Date().toISOString()
      };
    }

    async submit(event) {
      event.preventDefault();
      const data = this.payload();
      if (data.website) return;
      const button = this.form.querySelector('[type="submit"]');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Sending…';
      this.status('');

      try {
        if (!this.dataset.endpoint) {
          const subject = encodeURIComponent(`${data.lead_type} — ${data.first_name || ''} ${data.last_name || ''}`.trim());
          const body = encodeURIComponent(Object.entries(data)
            .filter(([key, value]) => value && !['website', 'destination_email', 'module'].includes(key))
            .map(([key, value]) => `${key.replaceAll('_', ' ')}: ${value}`).join('\n'));
          window.location.href = `mailto:${this.dataset.destinationEmail}?subject=${subject}&body=${body}`;
          this.status('Your email app has opened. Please send the prepared message to our sales team.', 'success');
          return;
        }

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(data),
          signal: controller.signal
        });
        clearTimeout(timeout);
        if (!response.ok) throw new Error('Lead request failed');
        this.form.reset();
        this.requestId = globalThis.crypto?.randomUUID?.() || `lead-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        this.status(this.dataset.successMessage || 'Thanks — your request is with our sales team.', 'success');
      } catch (error) {
        console.error(error);
        this.status(`We could not send the request. Please email ${this.dataset.destinationEmail}.`, 'error');
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    }
  }
  customElements.define('crm-lead-form', CrmLeadForm);
}
